/* eslint-disable perfectionist/sort-objects */
import type { FC, PropsWithChildren } from 'react'

import { createTheme, ThemeProvider } from '@mui/material/styles'

const theme = createTheme({
	palette: {
		primary: {
			main: 'hsl(173deg 87% 37%)' // ! Don't support css vars
			// dark: 'var(--primary-text)'
		}
	},

	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiOutlinedInput-input': {
						backgroundColor: '#fff',
						color: '#202020',
						fontSize: '0.875rem',
						fontWeight: 'normal',
						lineHeight: '1.43'
						// outlineColor: 'var(--primary)',
					},
					'& .MuiOutlinedInput-notchedOutline': {
						borderColor: 'var(--grey-nuance)'
					},
					'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: 'var(--primary)',
						borderWidth: '1px'
					},
					'&:hover .MuiOutlinedInput-notchedOutline': {
						borderColor: 'var(--primary)',
						borderWidth: '1px'
					},
					'& .MuiAutocomplete-popupIndicator:hover': {
						backgroundColor: 'transparent'
					}
				}
			}
		}
	},
	typography: {
		fontFamily: 'var(--main-font)'
	}
})

export const MUITheme: FC<PropsWithChildren> = ({ children }) => (
	<ThemeProvider theme={theme}> {children}</ThemeProvider>
)
